export const projects = [
  {
    title: 'Founders Language School',
    description:
      'This project belongs to the learning center called "Founders Langauge School". At first, the back-end was developed on Node.JS, but in the second version, Node was replaced with firebase. The website contains a Home page, Library page, Events page to register for events that the LC planned, and Admin Panel section.',
    image: 'founders.png',
    tags: ['Material-UI', 'React', 'Firebase'],
    source: 'https://github.com/KahhorovSh04/founders-mui',
    visit: 'https://founders.uz',
    id: 0,
  },
  {
    title: 'Agricultural Statistics',
    description:
      'I developed the project for the Ministry of Agriculture of the Republic of Uzbekistan. The project is a portion of the whole app that I cannot show, and it presents agricultural statistics.',
    image: 'agricultural-statistics.png',
    tags: ['HTML', 'Css', 'Apex Chart', 'JavaScript'],
    source: 'https://github.com/KahhorovSh04/agricultural-statistics',
    visit: 'https://agricultural-statistics.netlify.app/',
    id: 1,
  },
  {
    title: 'FreshGoods',
    description:
      'This is a landing page website for a grocery store. It is not complicated, but the simple design and shadow effect are great.',
    image: 'freshgoods.png',
    tags: ['HTML', 'Css', 'JavaScript'],
    source: 'https://github.com/KahhorovSh04/freshgoods',
    visit: 'https://freshgoods-shop.netlify.app/',
    id: 2,
  },
  {
    title: 'Reachat',
    description:
      'Using React, Sass and firebase, I developed real-time chat app. This is very basic app and for individual chats only. Sending text and photo message is available',
    image: 'reachat.png',
    tags: ['React', 'Sass', 'Firebase'],
    source: 'https://github.com/KahhorovSh04/reachat',
    visit: 'https://rea-chat.netlify.app',
    id: 3,
  },
  {
    title: 'Hotel BT',
    description:
      'This is one of my fist projects. Built with only HTML, CSS and Font Awesome Icons. Nothing special here, just the website that gives information about a hotel.',
    image: 'hbt.png',
    tags: ['HTML', 'CSS', 'Font Awesome'],
    source: 'https://github.com/KahhorovSh04/hbt',
    visit: 'https://h-bt.netlify.app',
    id: 4,
  },
]

export const experience = [
  {
    cardTitle: 'Mentor',
    cardSubtitle: 'RESULT ENGLISH SCHOOL',
    cardDetailedText:
      '• teaching English as a second language \n• guiding students in the sphere of teaching',
    time: '20/05/2020 – 15/05/2023',
    location: 'Tashkent, Uzbekistan',
  },
  {
    cardTitle: 'Project Manager',
    cardSubtitle: 'Khan Academy Uzbek',
    cardDetailedText:
      '• organizing new projects\n• applying for the International grants',
    location: 'Tashkent, Uzbekistan',
    time: '05/04/2022 – 16/06/2022',
  },
  {
    cardTitle: 'Update and Dispatch manager',
    cardSubtitle: 'Top Cargo LLC (Logistics)',
    cardDetailedText: '• updating brokers\n• dispatching drivers',
    location: 'Tashkent, Uzbekistan',
    time: '05/03/2023 – 05/04/2023',
  },
  {
    cardTitle: 'Academic Inspector',
    cardSubtitle: 'Millat Umidi School',
    cardDetailedText:
      "• checking qualification of teachers\n• working on school curriculum\n • enhancing student's thinking",
    location: 'Tashkent, Uzbekistan',
    time: '10/04/2023 – 10/05/2023',
  },
]
export const skills = [
  'Microsoft Office',
  'Microsoft Word',
  'Facebook',
  'Microsoft Powerpoint',
  'Social Media',
  'Instagram',
  'Advisor',
  'Decision-making',
  'Good listener and communicator',
  'Responsibility',
  'Diplomatic',
  'Thinker & Speaker',
]

export const languages = [
  {
    title: 'Uzbek',
    isNative: true,
  },
  {
    title: 'Russian',
    listening: 'C2',
    reading: 'C2',
    writing: 'C2',
    spokenInteraction: 'C2',
    spokenProduction: 'C2',
  },
  {
    title: 'English',
    listening: 'C2',
    reading: 'C1',
    writing: 'C1',
    spokenInteraction: 'C1',
    spokenProduction: 'C1',
  },
  {
    title: 'Turkish',
    listening: 'B1',
    reading: 'B2',
    writing: 'B1',
    spokenInteraction: 'B2',
    spokenProduction: 'B2',
  },
  {
    title: 'Arabic',
    listening: 'A1',
    reading: 'B1',
    writing: 'A1',
    spokenInteraction: 'A2',
    spokenProduction: 'A2',
  },
]

export const langScore = {
  A1: 10,
  A2: 20,
  B1: 40,
  B2: 60,
  C1: 80,
  C2: 100,
}
